module.exports = __webpack_public_path__ + "img/ua.8ea392c7.svg";